var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 18H24.75C24.8875 18 25 17.908 25 17.7955V16.1591C25 16.0466 24.8875 15.9545 24.75 15.9545L7.25 15.9545C7.1125 15.9545 7 16.0466 7 16.1591V17.7955C7 17.908 7.1125 18 7.25 18ZM0.250002 2.04545L24.75 2.04545C24.8875 2.04545 25 1.95341 25 1.84091V0.204546C25 0.0920467 24.8875 0 24.75 0L0.250002 0C0.112503 0 0 0.0920467 0 0.204546V1.84091C0 1.95341 0.112503 2.04545 0.250002 2.04545ZM0.250002 10.0227L24.75 10.0227C24.8875 10.0227 25 9.93068 25 9.81818V8.18182C25 8.06932 24.8875 7.97727 24.75 7.97727L0.250002 7.97727C0.112503 7.97727 0 8.06932 0 8.18182V9.81818C0 9.93068 0.112503 10.0227 0.250002 10.0227Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burgerMenu.1a7b8aaf.svg";
export { ForwardRef as ReactComponent };